// extracted by mini-css-extract-plugin
export default {"container":"styles_container__8xKMT","left-panel":"styles_left-panel__9dU+p","right-panel":"styles_right-panel__cCe5z"};